import type { ReactNode } from "react";
import { useI18n } from "../../i18n/I18nProvider";
import { messageKeyForError } from "../../i18n/errors";

export { Badge } from "./Badge";
export { ProgressBar } from "./ProgressBar";

/** Inline error text. Accepts any thrown value and shows its translated message. */
export function ErrorText({ error, children }: { error?: unknown; children?: ReactNode }) {
  const { t } = useI18n();
  if (error === undefined || error === null)
    return children ? (
      <p role="alert" className="text-note font-medium text-red">
        {children}
      </p>
    ) : null;
  return (
    <p role="alert" className="text-note font-medium text-red">
      {t(messageKeyForError(error))}
    </p>
  );
}

/** Board: white panel on the ice, soft blue-tinted depth, no border-left accents. */
export function Panel({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <section className={`rounded-panel bg-board p-4 shadow-board md:p-5 ${className}`}>
      {children}
    </section>
  );
}
